import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import {
	GetDatasetByIdQuery,
	GetDatasetByIdQueryVariables,
} from "~dataset-view/types/__generated/gql/graphql";
import { graphierQLNextClient } from "~utils/api/graphierQLNextClient";

const getDatasetByIdQuery = /* GraphQL */ `
	query GetDatasetById($id: ID!) {
		getDatasetById(id: $id) {
			id
			createdAt
			updatedAt
			name
			description
			userId
			type
			datasourceType
			sourceDatasetId
			size
			mapsCount
			legendUrl
			getCapabilitiesUrl
			isPrivate
			columns {
				name
				type
				subType
				width
				precision
				nullable
				uniqueConstraint
				defaultValue
				alias
				domainName
				comment
				timezone
			}
			bbox
			isSyncActive
			isAuthenticatedDropbox
			dropboxAccessToken
			dropboxFiles
			_layers {
				id

				_layerGroup {
					id

					_map {
						id
						name
						description
					}
				}
			}
		}
	}
`;

export const getDatasetByIdQueryKey = (id: string) => ["getDatasetById", id];

export const getDatasetByIdQueryFn = (
	variables: GetDatasetByIdQueryVariables,
) =>
	graphierQLNextClient<GetDatasetByIdQuery, GetDatasetByIdQueryVariables>({
		query: getDatasetByIdQuery,
		variables,
		useKey: true,
	}).then((res) => res.getDatasetById);

export const useGetDatasetById = (id: string) => {
	return useQuery({
		enabled: !!id,
		queryKey: getDatasetByIdQueryKey(id),
		queryFn: () => getDatasetByIdQueryFn({ id }),
	});
};

export const useGetCurrentDataset = () => {
	const {
		query: { "dataset-id": datasetId },
	} = useRouter();

	return useGetDatasetById(datasetId as string);
};
